package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.image.ImageTarget
import fr.manyverse.app.domain.repository.GmInventoryRepository
import fr.manyverse.app.domain.repository.ImageStorageRepository

class DeleteGmInventoryItemImageUseCase(
    private val imageStorageRepository: ImageStorageRepository,
    private val gmInventoryRepository: GmInventoryRepository
) {
    suspend operator fun invoke(tableId: String, itemId: String): Result<Unit> {
        imageStorageRepository.delete(ImageTarget.GmInventoryItem(tableId, itemId))
        return gmInventoryRepository.updateImageUrl(itemId, null).map { }
    }
}
